

















import { Component, Vue } from 'vue-property-decorator'
import { getSelectedCityId , isHzwApp } from '@utils/index'
import { find, toNumber } from 'lodash'
import { getCategoryList, getCmsData } from '../home-service'

@Component
export default class CategoryList extends Vue {
  cates: any[] | null = null
  cityList: any[] = []
  cityId : string|number= ''

  async created() {
    this.$setTitle('全部品类')
    this.$tracker('127', '121012981')()
    this.cityId = getSelectedCityId()
    const result = await getCategoryList(this.cityId)
    this.cates = result
    const { cityList = [] } = await getCmsData()
    this.cityList = cityList
  }

  jump(item: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012981', clickId: '200001', positionParam: { link: item.linkUrl, name: item.channelName } })

    if (item.channelType === 1) {
      // 频道类型(1：组件频道，2：跳转链接)
      if(isHzwApp()){
           location.href = `https://life.cekid.com/h5/channel/${item.channelId}?channelId=${item.channelId}`
        }else{
          this.$router.push({ name: 'channel', params: { channelId: item.channelId } })
        }
    } else {
      if (item.linkUrl) {
        if (item.linkUrl.indexOf('life.cekid.com/y/home') > -1) {
        
          //是不是甄选月嫂
          const selfOps = find(this.cityList, (item: any) => {
            return toNumber(this.cityId) === toNumber(item.cityCode) && 'selfOps' == item.signType
          })
          if (selfOps) {
            if ('月嫂' === item.channelName) {
              location.href = `//life.cekid.com/y/home?cmd=share&refresh=no&sharetype=0&swt=1&citycode=${this.cityId}`
            } else {
              location.href = '//life.cekid.com/y/selfCityYsList?swt=1'
            }
            return
          }
          //是不是签约月嫂
           const signYs = find(this.cityList, (item: any) => {
            return toNumber(this.cityId) === toNumber(item.cityCode) 
          })
           if (signYs) {
            if ('月嫂' === item.channelName) {
              location.href = `//life.cekid.com/y/home?cmd=share&refresh=no&sharetype=0&swt=1&citycode=${this.cityId}`
            } else {
              location.href = '//life.cekid.com/y/home?cmd=share&refresh=no&sharetype=0&swt=1'
            }
            return
          }
          location.href = '//life.cekid.com/y/home?cmd=share&refresh=no&sharetype=0&swt=1'
          return
        }
        if (item.linkUrl.indexOf('life.cekid.com/h5/category') > -1) {
           location.href = item.linkUrl + (item.linkUrl.indexOf('?') !== -1 ? '&' : '?') +'swt=1'
           return 
        }
        location.href = item.linkUrl
      }
    }
  }
}
